import AppSidebarElement from '../../components/AppSidebarElement/AppSidebarElement.vue'
import AppBurgerIcon from '../../components/AppBurgerIcon/AppBurgerIcon.vue'
import AppOverlay from '../../components/AppOverlay/AppOverlay.vue'
import { TimelineLite } from 'gsap'

export default {
    name: 'app-sidebar',
    props: ['markers'],
    components: {
        AppSidebarElement,
        AppBurgerIcon,
        AppOverlay
    },

    mounted() {
        const {sliderMenu} = this.$refs
        const timeline = new TimelineLite() 
        timeline.from(sliderMenu, 2, {
            opacity: 0,
            delay: .5,
        });
    },

    data () {
        return {
            menuOpened: true,
        };
    },
    
    methods: {
        hideMenu: function(){
            this.menuOpened = false;
        },
        toggleMenu: function(){
            this.menuOpened = !this.menuOpened;
        }
    }
}
